
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.766 8.19L6.099 3.374a2.5 2.5 0 00-3.333 3.083l1.283 4.042-1.317 4.041a2.5 2.5 0 002.342 3.292c.329 0 .655-.065.958-.192l11.709-4.816a2.5 2.5 0 000-4.617l.025-.017zM5.424 16.082a.833.833 0 01-.883-.158.833.833 0 01-.225-.834l1.216-3.758h11.442l-11.55 4.75zm.108-6.417L4.291 5.94a.833.833 0 01.225-.833.833.833 0 01.933-.192l11.525 4.75H5.532z","fill":"#fff"}})])
          )
        }
      }
    